import { render, staticRenderFns } from "./ClimateOnlineSummaryModal.vue?vue&type=template&id=fe7c1276"
import script from "./ClimateOnlineSummaryModal.vue?vue&type=script&lang=js"
export * from "./ClimateOnlineSummaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClimateOnlineStatistics: require('/app/components/climate-online/ClimateOnlineStatistics.vue').default,ClimateOnlineConnect: require('/app/components/climate-online/ClimateOnlineConnect.vue').default})
